import {Entity} from '../../../../../core/commons/entity';

export abstract class DynSelectFieldOptions<T> implements Entity {

    id: number;
    private type: string;
    private name: string;
    private options: Array<T>;

    getId(): number {
        return this.id;
    }

    setId(value: number) {
        this.id = value;
    }

    getType(): string {
        return this.type;
    }

    setType(value: string) {
        this.type = value;
    }

    getName(): string {
        return this.name;
    }

    setName(value: string) {
        this.name = value;
    }

    getOptions(): Array<T> {
        return this.options;
    }

    setOptions(value: Array<T>) {
        this.options = value;
    }

    abstract getValueAsString(value: T): string;

/*    public static createFromObject(object: Object): DynSelectFieldOptions<any> {
        switch (object['type']) {
            case 'city': return DynSelectFieldOptionsCity.createFromObject(object);
            case 'ministryArea': return DynSelectFieldOptionsMinistryArea.createFromObject(object);
            case 'ministry': return DynSelectFieldOptionsMinistry.createFromObject(object);
            case 'string': return DynSelectFieldOptionsString.createFromObject(object);
        }
    }

    protected updateFromObject(object: Object) {
        this._id = object['id'];
        this.name = object['name'];
    }
*/
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/select/dyn-select-field-options.ts